import React from 'react';
import { Microscope, ShieldCheck, Zap } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const OncologyPage = () => {
  const config = {
    badge: "Oncology Sanctuary",
    headline: "Compassionate",
    headlineItalic: "Cancer Care.",
    subtext: "Combining cutting-edge oncology with deep empathy to provide the best possible outcomes for pets facing cancer.",
    image: "/images/services/oncology.png",
    imageAlt: "Oncology at Dr. Suresh Pet Care — Advanced Cancer Treatment",
    stats: [
      { value: 800, suffix: '+', label: 'Cancer Cases Managed' },
      { value: 95, suffix: '%', label: 'Patient Quality of Life' },
      { value: 5, suffix: '+', label: 'Years Oncology Exp.' },
      { value: 24, suffix: '/7', label: 'Emergency Care' },
    ],
    services: [
      {
        title: "Oncology Diagnostics",
        icon: <Microscope size={28} />,
        desc: "Advanced staging, biopsy analysis, and HT Vista cancer-detecting machine protocols for early identification.",
        specs: ["Tumor Biopsy", "Systemic Staging", "HT Vista Audit", "Pathology Review"],
        color: "from-purple-500/10 to-primary/10"
      },
      {
        title: "Therapeutic Protocols",
        icon: <Zap size={28} />,
        desc: "Customized chemotherapy and medical management protocols designed to maintain high quality of life.",
        specs: ["Chemotherapy", "Immunotherapy", "Medical Management", "Supportive Care"],
        color: "from-primary/10 to-emerald-500/10"
      },
      {
        title: "Oncological Surgery",
        icon: <ShieldCheck size={28} />,
        desc: "Precision surgical removal of tumors and masses with focus on clear margins and reconstructive excellence.",
        specs: ["Wide Margin Excision", "Reconstructive Surgery", "Lymph Node Mapping", "Post-Op Recovery"],
        color: "from-rose-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Oncology",
    sectionItalic: "Capabilities.",
    warningTitle: "Oncology",
    warningItalic: "Warning Signs.",
    warningText: "Early detection is the most powerful tool in managing canine and feline cancer. Regular screenings can make a critical difference.",
    warnings: [
      { name: "Persistent Lumps", desc: "New lumps or growths that do not resolve or change rapidly in size.", icon: "🔍" },
      { name: "Non-healing Sores", desc: "Wounds or sores that fail to heal with standard care protocols.", icon: "⚠️" },
      { name: "Abnormal Swellings", desc: "Swellings in the abdomen, neck, or lymph node areas.", icon: "🫁" },
      { name: "Unexplained Weight Loss", desc: "Rapid weight loss despite normal or increased appetite.", icon: "📉" },
    ],
    ctaBadge: "Clinical Oncology",
    ctaTitle: "The Oncology",
    ctaItalic: "Expertise.",
    ctaText: "Led by advanced diagnostics and deep empathy, our oncology unit provides the best possible outcomes for pets facing cancer in Hyderabad.",
    ctaBtn: "Book Oncology Consult",
    seoText: "Advanced veterinary oncology in Hyderabad. Cancer treatment and tumor removal for pets at Dr. Suresh Pet Care. HT Vista cancer detection and chemotherapy services.",
    glowColor: "purple-500"
  };

  return (
    <>
      <SEO 
        title="Oncology & Cancer Treatment"
        description="Advanced cancer diagnosis, chemotherapy, and oncological surgery for pets at Dr. Suresh Pet Care. Compassionate cancer care unit in Hyderabad."
        canonical="/oncology"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default OncologyPage;
